import React from 'react';
import { Typography } from '@mui/material';
import PageLayout from '../components/layout/PageLayout';
import { TermsText } from '../components/auth/TermsAndConditions';

// The same licence terms people accept when they register
const Terms: React.FC = () => (
  <PageLayout title="Terms of use" subtitle="The licence terms you agree to when you create a Joan account.">
    <Typography variant="h6" component="h2" sx={{ mb: 1 }}>
      Ask Joan Mobile App EULA
    </Typography>
    <TermsText />
  </PageLayout>
);

export default Terms;
